import { gql } from '@apollo/client'

export const DENY_VACCINATION = gql`
  mutation DenyVaccination($inputData: DenyVaccinationInput!) {
    denyVaccination(inputData: $inputData) {
      id
    }
  }
`
